import { render, staticRenderFns } from "./sectionMediumHome.vue?vue&type=template&id=59ee8c80&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sectionMediumHome.vue"
export default component.exports